// Dependencias generales
import React from "react";
import { useEffect } from 'react';
import AppLogoImg from '../../components/Utils/AppLogoImg';
import Loader from '../../components/Utils/Loader';
import ReactGA from "react-ga4";

const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const postInitialConfigDevicesList = endpointHelias+"/Helias/V0/Configuration/postInitialConfigDevicesList"

var initialConfigCommonJS = require("../../js/initialConfigCommon.js");
var generalCommonJS = require("../../js/generalCommon.js")

const AppRegistrationForm = (params) => {

  useEffect(() => {              

    actualizarVisibilidadCamposFormulario(params.AppName)
    actualizarVisibilidadMensajesFormulario()
    incluirMostrarOcultarPwd()        

    
  });
  
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {   
      event.preventDefault()   
      registrarNuevaCuenta()
    }
  }  

  function actualizarVisibilidadCamposFormulario(appName){        
    
    document.getElementById("labelCampoUsuario1").innerHTML = "Usuario"            
    document.getElementById("campoUsuario1").value = ""
    document.getElementById("campoUsuario2").value = ""
    document.getElementById("campoUsuario3").value = ""
    document.getElementById("labelCampoContraseña").innerHTML = "Contraseña"
    document.getElementById("fieldsetPassword").className="password"
    document.getElementById("campoContraseña").type = "password"
    document.getElementById("campoContraseña").value = ""
    document.getElementById("labelCampoToken").innerHTML = "Token"       
    document.getElementById("campoToken").value = ""
    document.getElementById("botonConectarRegistro").style="display"      

    if((appName === "EFERGY") || (appName === "TESLA")){
      document.getElementById("fieldsetUsuario").style="display: none"
      document.getElementById("fieldsetPassword").style="display: none"
      document.getElementById("fieldsetToken").style="display"
    }
    else if(appName === "SHELLY"){            
      document.getElementById("campoUsuario1").value = ""
      document.getElementById("labelCampoContraseña").innerHTML = "Nº Servidor"
      document.getElementById("labelCampoToken").innerHTML = "API Key"
      document.getElementById("fieldsetUsuario").style="display: none"
      document.getElementById("fieldsetPassword").style="display"
      document.getElementById("fieldsetPassword").className=""
      document.getElementById("campoContraseña").type = "text"
      document.getElementById("fieldsetToken").style="display"
    }
    else if( (appName === "TUYA") || (appName === "SMARTLIFE") ){            
      document.getElementById("labelCampoUsuario1").innerHTML = "Access ID"      
      document.getElementById("labelCampoContraseña").innerHTML = "Access Secret"
      document.getElementById("labelCampoToken").innerHTML = "User ID"
      document.getElementById("fieldsetUsuario").style="display"
      document.getElementById("fieldsetPassword").style="display"
      document.getElementById("fieldsetPassword").className=""
      document.getElementById("campoContraseña").type = "text"
      document.getElementById("fieldsetToken").style="display"
    }
    else if(appName === "HOME_ASSISTANT"){            
      document.getElementById("labelCampoUsuario1").innerHTML = "Servidor"      
      document.getElementById("labelCampoContraseña").innerHTML = "Puerto"
      document.getElementById("labelCampoToken").innerHTML = "Token"
      document.getElementById("fieldsetUsuario").style="display"
      document.getElementById("fieldsetPassword").style="display"
      document.getElementById("fieldsetPassword").className=""
      document.getElementById("campoContraseña").type = "text"
      document.getElementById("fieldsetToken").style="display"
    }
    else if(appName === "KOSTAL_LOCAL"){            
      document.getElementById("labelCampoUsuario1").innerHTML = "Servidor"      
      document.getElementById("labelCampoContraseña").innerHTML = "Contraseña"
      document.getElementById("labelCampoToken").innerHTML = "Puerto"
      document.getElementById("fieldsetUsuario").style="display"
      document.getElementById("fieldsetPassword").style="display"
      document.getElementById("fieldsetPassword").className=""
      document.getElementById("campoContraseña").type = "text"
      document.getElementById("fieldsetToken").style="display"
    }
    else if(appName === "ONECTA_DAIKIN"){            
      document.getElementById("labelCampoUsuario1").innerHTML = "Client ID"      
      document.getElementById("labelCampoContraseña").innerHTML = "Client Secret"
      document.getElementById("labelCampoToken").innerHTML = "Código"
      document.getElementById("fieldsetUsuario").style="display"
      document.getElementById("fieldsetPassword").style="display"
      document.getElementById("fieldsetPassword").className=""
      document.getElementById("campoContraseña").type = "text"
      document.getElementById("fieldsetToken").style="display"
      document.getElementById("botonConectarRegistro").style="display: none"      
    }
    else if(appName === "GOVEE"){            
      document.getElementById("labelCampoUsuario1").innerHTML = ""      
      document.getElementById("labelCampoContraseña").innerHTML = ""
      document.getElementById("labelCampoToken").innerHTML = "API Key"
      document.getElementById("fieldsetUsuario").style="display: none"
      document.getElementById("fieldsetPassword").style="display: none"
      document.getElementById("fieldsetPassword").className=""
      document.getElementById("campoContraseña").type = "text"
      document.getElementById("fieldsetToken").style="display"
      document.getElementById("botonConectarRegistro").style="display"      
    }
    else if(appName === "XIAOMI"){                  

      document.getElementById("XiaomiPaso1").className = document.getElementById("XiaomiPaso1").className.replaceAll(" hidden", "")
      document.getElementById("usuarioXiaomi").value = ""
      document.getElementById("passwordXiaomi").value = ""

      document.getElementById("XiaomiPaso2").className = document.getElementById("XiaomiPaso2").className.replaceAll(" hidden", "") + " hidden"

      document.getElementById("labelCampoUsuario1").innerHTML = "cUserId"            
      document.getElementById("labelCampoContraseña").innerHTML = "serviceToken"
      document.getElementById("labelCampoToken").innerHTML = "ssecurity"
      document.getElementById("fieldsetUsuario").style="display: none"
      document.getElementById("fieldsetPassword").style="display: none"
      document.getElementById("fieldsetPassword").className=""
      document.getElementById("campoContraseña").type = "text"
      document.getElementById("fieldsetToken").style="display: none"
      document.getElementById("botonConectarRegistro").style="display: none"

      incluirMostrarOcultarPwd()      
    }
    else if(appName === "SMARTTHINGS"){            
      document.getElementById("labelCampoUsuario1").innerHTML = ""      
      document.getElementById("labelCampoContraseña").innerHTML = ""
      document.getElementById("labelCampoToken").innerHTML = "Token"
      document.getElementById("fieldsetUsuario").style="display:none"
      document.getElementById("fieldsetPassword").style="display:none"
      document.getElementById("fieldsetPassword").className=""
      document.getElementById("campoContraseña").type = "text"
      document.getElementById("fieldsetToken").style="display"
      document.getElementById("botonConectarRegistro").style="display"      
    }
    else{            
      document.getElementById("divCampoUsuario2").className += " hidden"      
      document.getElementById("divCampoUsuario3").className += " hidden"
      document.getElementById("fieldsetUsuario").style="display"
      document.getElementById("fieldsetPassword").style="display"
      document.getElementById("fieldsetToken").style="display: none"
    }    
  }

  function actualizarVisibilidadMensajesFormulario(){

    document.getElementById("divBotonSolicitudCodigoOauth").className = document.getElementById("divBotonSolicitudCodigoOauth").className.replaceAll(" hidden", "") + " hidden"  
    document.getElementById("divAutenticacionXiaomi").className = document.getElementById("divAutenticacionXiaomi").className.replaceAll(" hidden", "") + " hidden"
    document.getElementById("campoUsuario1").className = ""
    document.getElementById("campoContraseña").className = ""
    document.getElementById("campoToken").className = ""

    if(params.AppName === "TESLA"){            
      
      document.getElementById("divMensajeIberdrolaSmartMonitor").className = document.getElementById("divMensajeIberdrolaSmartMonitor").className.replaceAll(" hidden", "") + " hidden"                  
      document.getElementById("divMensajeEDPSolar").className = document.getElementById("divMensajeEDPSolar").className.replaceAll(" hidden", "") + " hidden"                 
      document.getElementById("divMensajeWarningENERGEEKS_30").className = document.getElementById("divMensajeWarningENERGEEKS_30").className.replaceAll(" hidden", "") + " hidden"                                

      if(generalCommonJS.obtenerTipoPlataforma() !== "Web"){
        document.getElementById("divMensajeWarningTESLA").className = document.getElementById("divMensajeWarningTESLA").className.replaceAll(" hidden", "")      
        document.getElementById("divMensajeWarning").className = document.getElementById("divMensajeWarning").className.replaceAll(" hidden", "") + " hidden"       
        document.getElementById("formularioCredenciales").className = document.getElementById("formularioCredenciales").className.replaceAll(" hidden", "") + " hidden" 
      }
      else{
        document.getElementById("divMensajeWarningTESLA").className = document.getElementById("divMensajeWarningTESLA").className.replaceAll(" hidden", "") + " hidden"
        document.getElementById("divMensajeWarning").className = document.getElementById("divMensajeWarning").className.replaceAll(" hidden", "")                
        document.getElementById("formularioCredenciales").className = document.getElementById("formularioCredenciales").className.replaceAll(" hidden", "")         
      }

    }
    else if((params.AppName === "TUYA") || (params.AppName === "SMARTLIFE") ){
      document.getElementById("divMensajeWarningTESLA").className = document.getElementById("divMensajeWarningTESLA").className.replaceAll(" hidden", "") + " hidden"      
      document.getElementById("formularioCredenciales").className = document.getElementById("formularioCredenciales").className.replaceAll(" hidden", "")             
      document.getElementById("divMensajeWarning").className = document.getElementById("divMensajeWarning").className.replaceAll(" hidden", "")                 
      document.getElementById("textoMensajeWarning").innerHTML = "Te recomendamos que lo realices desde un ordenador ya que el tiempo estimado de registro es de <strong>5 minutos</strong> y en algún momento vas a tener que escanear un QR con el teléfono móvil."      
      document.getElementById("divMensajeIberdrolaSmartMonitor").className = document.getElementById("divMensajeIberdrolaSmartMonitor").className.replaceAll(" hidden", "") + " hidden"                  
      document.getElementById("divMensajeEDPSolar").className = document.getElementById("divMensajeEDPSolar").className.replaceAll(" hidden", "") + " hidden"                 
      document.getElementById("divMensajeWarningENERGEEKS_30").className = document.getElementById("divMensajeWarningENERGEEKS_30").className.replaceAll(" hidden", "") + " hidden"                                
    }
    else if(params.AppName === "SHELLY"){
      document.getElementById("divMensajeWarningTESLA").className = document.getElementById("divMensajeWarningTESLA").className.replaceAll(" hidden", "") + " hidden"      
      document.getElementById("formularioCredenciales").className = document.getElementById("formularioCredenciales").className.replaceAll(" hidden", "")             
      document.getElementById("divMensajeWarning").className = document.getElementById("divMensajeWarning").className.replaceAll(" hidden", "")                 
      document.getElementById("textoMensajeWarning").innerHTML = "El tiempo estimado de registro es de <strong>3 minutos</strong>."      
      document.getElementById("divMensajeIberdrolaSmartMonitor").className = document.getElementById("divMensajeIberdrolaSmartMonitor").className.replaceAll(" hidden", "") + " hidden"                  
      document.getElementById("divMensajeEDPSolar").className = document.getElementById("divMensajeEDPSolar").className.replaceAll(" hidden", "") + " hidden"                 
      document.getElementById("divMensajeWarningENERGEEKS_30").className = document.getElementById("divMensajeWarningENERGEEKS_30").className.replaceAll(" hidden", "") + " hidden"                                  
    }
    else if(params.AppName === "EFERGY"){
      document.getElementById("divMensajeWarningTESLA").className = document.getElementById("divMensajeWarningTESLA").className.replaceAll(" hidden", "") + " hidden"      
      document.getElementById("formularioCredenciales").className = document.getElementById("formularioCredenciales").className.replaceAll(" hidden", "")             
      document.getElementById("divMensajeWarning").className = document.getElementById("divMensajeWarning").className.replaceAll(" hidden", "")                 
      document.getElementById("textoMensajeWarning").innerHTML = "El tiempo estimado de registro es de <strong>2 minutos</strong>."      
      document.getElementById("divMensajeIberdrolaSmartMonitor").className = document.getElementById("divMensajeIberdrolaSmartMonitor").className.replaceAll(" hidden", "") + " hidden"                  
      document.getElementById("divMensajeEDPSolar").className = document.getElementById("divMensajeEDPSolar").className.replaceAll(" hidden", "") + " hidden"                 
      document.getElementById("divMensajeWarningENERGEEKS_30").className = document.getElementById("divMensajeWarningENERGEEKS_30").className.replaceAll(" hidden", "") + " hidden"                                  
    }
    else if(params.AppName === "HOME_ASSISTANT"){
      document.getElementById("divMensajeWarningTESLA").className = document.getElementById("divMensajeWarningTESLA").className.replaceAll(" hidden", "") + " hidden"      
      document.getElementById("formularioCredenciales").className = document.getElementById("formularioCredenciales").className.replaceAll(" hidden", "")             
      document.getElementById("divMensajeWarning").className = document.getElementById("divMensajeWarning").className.replaceAll(" hidden", "")                 
      document.getElementById("textoMensajeWarning").innerHTML = "El tiempo estimado de registro es de <strong>5 minutos</strong>."      
      document.getElementById("divMensajeIberdrolaSmartMonitor").className = document.getElementById("divMensajeIberdrolaSmartMonitor").className.replaceAll(" hidden", "") + " hidden"                  
      document.getElementById("divMensajeEDPSolar").className = document.getElementById("divMensajeEDPSolar").className.replaceAll(" hidden", "") + " hidden"                 
      document.getElementById("divMensajeWarningENERGEEKS_30").className = document.getElementById("divMensajeWarningENERGEEKS_30").className.replaceAll(" hidden", "") + " hidden"                                  
    }
    else if(params.AppName === "ECOFORESTCONTROL"){
      document.getElementById("divMensajeWarningTESLA").className = document.getElementById("divMensajeWarningTESLA").className.replaceAll(" hidden", "") + " hidden"      
      document.getElementById("formularioCredenciales").className = document.getElementById("formularioCredenciales").className.replaceAll(" hidden", "")             
      document.getElementById("divMensajeWarning").className = document.getElementById("divMensajeWarning").className.replaceAll(" hidden", "")                 
      document.getElementById("textoMensajeWarning").innerHTML = "El tiempo estimado de registro es de <strong>2 minutos</strong>."      
      document.getElementById("divMensajeIberdrolaSmartMonitor").className = document.getElementById("divMensajeIberdrolaSmartMonitor").className.replaceAll(" hidden", "") + " hidden"                  
      document.getElementById("divMensajeEDPSolar").className = document.getElementById("divMensajeEDPSolar").className.replaceAll(" hidden", "") + " hidden"                 
      document.getElementById("divMensajeWarningENERGEEKS_30").className = document.getElementById("divMensajeWarningENERGEEKS_30").className.replaceAll(" hidden", "") + " hidden"                                  
    }
    else if(params.AppName === "IBERDROLA_SMART_MONITOR"){
      document.getElementById("divMensajeWarningTESLA").className = document.getElementById("divMensajeWarningTESLA").className.replaceAll(" hidden", "") + " hidden"      
      document.getElementById("formularioCredenciales").className = document.getElementById("formularioCredenciales").className.replaceAll(" hidden", "") + " hidden"            
      document.getElementById("divMensajeWarning").className = document.getElementById("divMensajeWarning").className.replaceAll(" hidden", "") + " hidden"      
      document.getElementById("divMensajeIberdrolaSmartMonitor").className = document.getElementById("divMensajeIberdrolaSmartMonitor").className.replaceAll(" hidden", "")           
      document.getElementById("divMensajeEDPSolar").className = document.getElementById("divMensajeEDPSolar").className.replaceAll(" hidden", "") + " hidden"                 
      document.getElementById("divMensajeWarningENERGEEKS_30").className = document.getElementById("divMensajeWarningENERGEEKS_30").className.replaceAll(" hidden", "") + " hidden"                                
    }
    else if(params.AppName === "EDP_SOLAR"){
      document.getElementById("divMensajeWarningTESLA").className = document.getElementById("divMensajeWarningTESLA").className.replaceAll(" hidden", "") + " hidden"      
      document.getElementById("formularioCredenciales").className = document.getElementById("formularioCredenciales").className.replaceAll(" hidden", "") + " hidden"                 
      document.getElementById("divMensajeWarning").className = document.getElementById("divMensajeWarning").className.replaceAll(" hidden", "") + " hidden"      
      document.getElementById("divMensajeIberdrolaSmartMonitor").className = document.getElementById("divMensajeIberdrolaSmartMonitor").className.replaceAll(" hidden", "") + " hidden"      
      document.getElementById("divMensajeEDPSolar").className = document.getElementById("divMensajeEDPSolar").className.replaceAll(" hidden", "")                  
      document.getElementById("divMensajeWarningENERGEEKS_30").className = document.getElementById("divMensajeWarningENERGEEKS_30").className.replaceAll(" hidden", "") + " hidden"                                
    }
    else if(params.AppName === "ENERGEEKS_30"){
      document.getElementById("divMensajeWarningTESLA").className = document.getElementById("divMensajeWarningTESLA").className.replaceAll(" hidden", "") + " hidden"      
      document.getElementById("formularioCredenciales").className = document.getElementById("formularioCredenciales").className.replaceAll(" hidden", "") + " hidden"          
      document.getElementById("divMensajeWarning").className = document.getElementById("divMensajeWarning").className.replaceAll(" hidden", "") + " hidden"      
      document.getElementById("divMensajeIberdrolaSmartMonitor").className = document.getElementById("divMensajeIberdrolaSmartMonitor").className.replaceAll(" hidden", "") + " hidden"     
      document.getElementById("divMensajeEDPSolar").className = document.getElementById("divMensajeEDPSolar").className.replaceAll(" hidden", "") + " hidden"                  
      document.getElementById("divMensajeWarningENERGEEKS_30").className = document.getElementById("divMensajeWarningENERGEEKS_30").className.replaceAll(" hidden", "")                 
    }
    else if(params.AppName === "ONECTA_DAIKIN"){
      document.getElementById("divMensajeWarningTESLA").className = document.getElementById("divMensajeWarningTESLA").className.replaceAll(" hidden", "") + " hidden"      
      document.getElementById("formularioCredenciales").className = document.getElementById("formularioCredenciales").className.replaceAll(" hidden", "")             
      document.getElementById("divMensajeWarning").className = document.getElementById("divMensajeWarning").className.replaceAll(" hidden", "")
      document.getElementById("textoMensajeWarning").innerHTML = "El tiempo estimado de registro es de <strong>5 minutos</strong>."
      document.getElementById("divMensajeIberdrolaSmartMonitor").className = document.getElementById("divMensajeIberdrolaSmartMonitor").className.replaceAll(" hidden", "") + " hidden"                  
      document.getElementById("divMensajeEDPSolar").className = document.getElementById("divMensajeEDPSolar").className.replaceAll(" hidden", "") + " hidden"                 
      document.getElementById("divMensajeWarningENERGEEKS_30").className = document.getElementById("divMensajeWarningENERGEEKS_30").className.replaceAll(" hidden", "") + " hidden"                                
      document.getElementById("divBotonSolicitudCodigoOauth").className = document.getElementById("divBotonSolicitudCodigoOauth").className.replaceAll(" hidden", "")
    }
    else if(params.AppName === "GOVEE"){
      document.getElementById("divMensajeWarningTESLA").className = document.getElementById("divMensajeWarningTESLA").className.replaceAll(" hidden", "") + " hidden"      
      document.getElementById("formularioCredenciales").className = document.getElementById("formularioCredenciales").className.replaceAll(" hidden", "")             
      document.getElementById("divMensajeWarning").className = document.getElementById("divMensajeWarning").className.replaceAll(" hidden", "")
      document.getElementById("textoMensajeWarning").innerHTML = "El tiempo estimado de registro es de <strong>2 minutos</strong>."
      document.getElementById("divMensajeIberdrolaSmartMonitor").className = document.getElementById("divMensajeIberdrolaSmartMonitor").className.replaceAll(" hidden", "") + " hidden"                  
      document.getElementById("divMensajeEDPSolar").className = document.getElementById("divMensajeEDPSolar").className.replaceAll(" hidden", "") + " hidden"                 
      document.getElementById("divMensajeWarningENERGEEKS_30").className = document.getElementById("divMensajeWarningENERGEEKS_30").className.replaceAll(" hidden", "") + " hidden"                                
      document.getElementById("divBotonSolicitudCodigoOauth").className = document.getElementById("divBotonSolicitudCodigoOauth").className.replaceAll(" hidden", "") + " hidden"
    }
    else if(params.AppName === "XIAOMI"){
      document.getElementById("divMensajeWarningTESLA").className = document.getElementById("divMensajeWarningTESLA").className.replaceAll(" hidden", "") + " hidden"      
      document.getElementById("formularioCredenciales").className = document.getElementById("formularioCredenciales").className.replaceAll(" hidden", "")             
      document.getElementById("divMensajeWarning").className = document.getElementById("divMensajeWarning").className.replaceAll(" hidden", "")      
      document.getElementById("textoMensajeWarning").innerHTML = "El registro de esta aplicación requiere del uso de un ordenador ya que en algún momento vas a tener que utilizar funciones avanzadas del navegador. El tiempo estimado de registro es de <strong>5 minutos</strong>."      
      document.getElementById("divMensajeIberdrolaSmartMonitor").className = document.getElementById("divMensajeIberdrolaSmartMonitor").className.replaceAll(" hidden", "") + " hidden"                  
      document.getElementById("divMensajeEDPSolar").className = document.getElementById("divMensajeEDPSolar").className.replaceAll(" hidden", "") + " hidden"                 
      document.getElementById("divMensajeWarningENERGEEKS_30").className = document.getElementById("divMensajeWarningENERGEEKS_30").className.replaceAll(" hidden", "") + " hidden"                                
      document.getElementById("divBotonSolicitudCodigoOauth").className = document.getElementById("divBotonSolicitudCodigoOauth").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("divAutenticacionXiaomi").className = document.getElementById("divAutenticacionXiaomi").className.replaceAll(" hidden", "")        
    }
    else if(params.AppName === "SMARTTHINGS"){
      document.getElementById("divMensajeWarningTESLA").className = document.getElementById("divMensajeWarningTESLA").className.replaceAll(" hidden", "") + " hidden"      
      document.getElementById("formularioCredenciales").className = document.getElementById("formularioCredenciales").className.replaceAll(" hidden", "")             
      document.getElementById("divMensajeWarning").className = document.getElementById("divMensajeWarning").className.replaceAll(" hidden", "")                 
      document.getElementById("textoMensajeWarning").innerHTML = "El tiempo estimado de registro es de <strong>2 minutos</strong>."      
      document.getElementById("divMensajeIberdrolaSmartMonitor").className = document.getElementById("divMensajeIberdrolaSmartMonitor").className.replaceAll(" hidden", "") + " hidden"                  
      document.getElementById("divMensajeEDPSolar").className = document.getElementById("divMensajeEDPSolar").className.replaceAll(" hidden", "") + " hidden"                 
      document.getElementById("divMensajeWarningENERGEEKS_30").className = document.getElementById("divMensajeWarningENERGEEKS_30").className.replaceAll(" hidden", "") + " hidden"                                  
    }
    else{
      document.getElementById("divMensajeWarningTESLA").className = document.getElementById("divMensajeWarningTESLA").className.replaceAll(" hidden", "") + " hidden"      
      document.getElementById("formularioCredenciales").className = document.getElementById("formularioCredenciales").className.replaceAll(" hidden", "")            
      document.getElementById("divMensajeWarning").className = document.getElementById("divMensajeWarning").className.replaceAll(" hidden", "") + " hidden"                  
      document.getElementById("divMensajeIberdrolaSmartMonitor").className = document.getElementById("divMensajeIberdrolaSmartMonitor").className.replaceAll(" hidden", "") + " hidden" 
      document.getElementById("divMensajeEDPSolar").className = document.getElementById("divMensajeEDPSolar").className.replaceAll(" hidden", "") + " hidden"                 
      document.getElementById("divMensajeWarningENERGEEKS_30").className = document.getElementById("divMensajeWarningENERGEEKS_30").className.replaceAll(" hidden", "") + " hidden"                                
    }
  }

  const incluirMostrarOcultarPwd = (event) => {

    var passwordFields = document.querySelectorAll('fieldset.password');
    var passwordWrapper = ""

    if(passwordFields[0] !== undefined){

      var indiceCampoContraseña = 1

      if(params.AppName === "XIAOMI"){
        indiceCampoContraseña = 0
      }

      try{
        passwordWrapper = passwordFields[indiceCampoContraseña].querySelector('.icon-wrapper');
        passwordWrapper.onclick = function(event){
          togglePasswordVisibility(event,passwordWrapper);
        }
      }
      catch(error){}

    }
    
  }

  function togglePasswordVisibility(e,passwordWrapper) {
    
    var passwordField = passwordWrapper.querySelector('input');

    if(e.target === passwordWrapper) {
      if ( passwordField.type === "password" ) {
        passwordWrapper.classList.add('visible');
        passwordField.type = "text";
      } else{
        passwordWrapper.classList.remove('visible');
        passwordField.type = "password";
      }
    };
  };

  function registrarNuevaCuenta(){

    var marca = params.AppName
    var contraseña = document.getElementById("campoContraseña").value
    var procederConRegistro = true

    //Prevalidaciones específias
    if( (marca === "SHELLY") && (contraseña.length > 4) ){
      initialConfigCommonJS.mostrarMensajeInformativo("Sólo debes introducir el número del servidor. Para más información pulsa en el icono de información al lado de 'Nº Servidor'.","negative")
      procederConRegistro = false
    }

    if(procederConRegistro){
      document.getElementById("divContenedorOpcionesApps").scrollTop = 0

      document.getElementById("loaderRegistroAplicacion").className="loader overlay"

      var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
      var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
      var ongoingInstallationConfigurationID = localStorage.getItem("ongoingInstallationConfiguration")    
          
      var usuario = ""
      var idSecundarioEstufa = ""

      if(document.getElementById("marcaEstufa") !== null){
        idSecundarioEstufa += document.getElementById("marcaEstufa").value
      }

      if(document.getElementById("Puerto") !== null){
        idSecundarioEstufa += "|"+ document.getElementById("Puerto").value
      }

      if(document.getElementById("divCampoUsuario2").className.includes(" hidden")){
        document.getElementById("campoUsuario2").value = ""
      }
      if(document.getElementById("divCampoUsuario3").className.includes(" hidden")){
        document.getElementById("campoUsuario3").value = ""
      }
      
      if(document.getElementById("campoUsuario1").value !== ""){
        usuario = document.getElementById("campoUsuario1").value  
      }
      if(document.getElementById("campoUsuario2").value !== ""){
        usuario += "|"+document.getElementById("campoUsuario2").value  
      }
      if(document.getElementById("campoUsuario3").value !== ""){
        usuario += "|"+document.getElementById("campoUsuario3").value  
      }
      
      var token = ""

      if(idSecundarioEstufa === ""){
        token = document.getElementById("campoToken").value
      }
      else{
        token = idSecundarioEstufa
      }

      var camposSensores = initialConfigCommonJS.obtenerCamposSensores()
      var camposDispositivos = initialConfigCommonJS.obtenerCamposDispositivos()
      var camposCoches = initialConfigCommonJS.obtenerCamposCoches()
      
      var data = ""

      var encriptionKey = ongoingInstallationConfigurationID.substring(0,16);
      
      //Cifro las credenciales durante el tránsito
      var CryptoJS = require("crypto-js");
      usuario = CryptoJS.AES.encrypt(usuario, encriptionKey).toString();        
      contraseña = CryptoJS.AES.encrypt(contraseña, encriptionKey).toString();  
      token = CryptoJS.AES.encrypt(token, encriptionKey).toString();    

      if(camposSensores.toString().includes(localStorage.getItem("deviceToConfigure"))){
        data = JSON.stringify({ "accountID": localStorage.getItem("accountID"), "InstallationID": ongoingInstallationConfigurationID, "Marca": marca, "Usuario": usuario, "Contraseña": contraseña, "Token": token })
      }
      else if( (camposDispositivos.toString().includes(localStorage.getItem("deviceToConfigure"))) || (localStorage.getItem("ongoingStepConfiguration") === "DEVICES") ){        
        data = JSON.stringify({ "accountID": localStorage.getItem("accountID"), "InstallationID": ongoingInstallationConfigurationID, "Marca": marca, "Usuario": usuario, "Contraseña": contraseña, "Token": token , "TipoPeticion": "DEVICES"})        
      }
      else if(camposCoches.toString().includes(localStorage.getItem("deviceToConfigure"))){
        data = JSON.stringify({ "accountID": localStorage.getItem("accountID"), "InstallationID": ongoingInstallationConfigurationID, "Marca": marca, "Usuario": usuario, "Contraseña": contraseña, "Token": token })
      }
      else{ //Default
        data = JSON.stringify({ "accountID": localStorage.getItem("accountID"), "InstallationID": ongoingInstallationConfigurationID, "Marca": marca, "Usuario": usuario, "Contraseña": contraseña, "Token": token })
      } 
      
      if( (localStorage.getItem("devicesAction") !== null) && (localStorage.getItem("devicesAction") === "MODIFICATION") ){
        data = JSON.parse(data)
        data.Accion = "MODIFICATION"
        data = JSON.stringify(data)
      }
      
      var xhttp = new XMLHttpRequest();  
      xhttp.open("POST", postInitialConfigDevicesList, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");
      xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);    
      xhttp.onreadystatechange = function() {
          
        if (this.readyState === 4 && this.status === 200) {
            
          var jsonRespuestaDispositivos = JSON.parse(this.responseText)
          
          if(jsonRespuestaDispositivos.statusCode === "200"){
            
            generalCommonJS.registrarEventoAnalitica(ReactGA, 'CONFIGURACIÓN', 'APP REGISTRADA - '+marca, "", "")

            if(localStorage.getItem("installationConfigurationMode") !== null){
              localStorage.setItem("forceUpdate", "true")
            }
            
            localStorage.removeItem("configuredApps")

            console.log("Cuenta registrada correctamente")                        
            
            var campoDispositivoActual = localStorage.getItem("deviceToConfigure")
      
            if(campoDispositivoActual !== null){ //Estoy en un paso normal              
              initialConfigCommonJS.CargarCuentasAplicacionesRegistradas(params.setAvailableApps)
              params.setAvailableDevices(jsonRespuestaDispositivos.body)
              console.log("Dispositivos actualizados correctamente")   
              document.getElementById("loaderRegistroAplicacion").className="loader hidden"
            }
            else{ //Estoy en el paso de dispositivos              
              initialConfigCommonJS.CargarCuentasAplicacionesRegistradas(params.setDevicesApps)
              params.setDevicesList(jsonRespuestaDispositivos.body)
              console.log("Dispositivos actualizados correctamente")   
              document.getElementById("loaderRegistroAplicacion").className="loader hidden"            
              document.getElementById("divMensajeError").className += " hidden"
              initialConfigCommonJS.operarMenuLateral("cerrar")
              initialConfigCommonJS.mostrarMensajeInformativo("Aplicación registrada correctamente","positive")
            }

            initialConfigCommonJS.navegarFlujoAplicacionesDispositivos("listadoDispositivosDisponibles","noUpdate")

          }

          else{
            document.getElementById("loaderRegistroAplicacion").className="loader hidden"          
            document.getElementById("divMensajeError").className = document.getElementById("divMensajeError").className.replaceAll(" hidden", "")

            console.log(jsonRespuestaDispositivos)

            if(document.getElementById("mensajeErrorRegistro") !== undefined){
              document.getElementById("mensajeErrorRegistro").innerHTML = jsonRespuestaDispositivos.responseMessage.replaceAll("_", " ")
            }          

          }
        }
    
        if (this.readyState === 4 && this.status !== 200) { 
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)      
        }
      }
      xhttp.send(data);    
    }
    
  }

  function obtenerLinkXiaomiP1(){

    var usuarioForm = document.getElementById("usuarioXiaomi").value
    var contraseñaForm = document.getElementById("passwordXiaomi").value

    if((usuarioForm !== "") && (contraseñaForm !== "")){

      document.getElementById("divContenedorOpcionesApps").scrollTop = 0
      document.getElementById("loaderRegistroAplicacion").className="loader overlay"

      var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
      var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
      var ongoingInstallationConfigurationID = localStorage.getItem("ongoingInstallationConfiguration")    
      
      var encriptionKey = ongoingInstallationConfigurationID.substring(0,16);

      //Cifro las credenciales durante el tránsito
      var CryptoJS = require("crypto-js");
      var usuario = CryptoJS.AES.encrypt(usuarioForm, encriptionKey).toString();        
      var contraseña = CryptoJS.AES.encrypt(contraseñaForm, encriptionKey).toString();  

      var data = JSON.stringify({ "accountID": localStorage.getItem("accountID"), "InstallationID": ongoingInstallationConfigurationID, "Marca": "XIAOMI", "Usuario": usuario, "Contraseña": contraseña, "Token": "" , "TipoPeticion": "XIAOMIP1"})        

      var xhttp = new XMLHttpRequest();  
        xhttp.open("POST", postInitialConfigDevicesList, true);        
        xhttp.setRequestHeader('Content-Type', "application/json");
        xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);    
        xhttp.onreadystatechange = function() {
            
          if (this.readyState === 4 && this.status === 200) {
              
            var jsonRespuestaDispositivos = JSON.parse(this.responseText)
            
            if(jsonRespuestaDispositivos.statusCode === "200"){            

              console.log(jsonRespuestaDispositivos)

              var xiaomiMfaLink = jsonRespuestaDispositivos.body.xiaomiMfaLink

              if(xiaomiMfaLink !== ""){ //Credenciales correctas

                document.getElementById("xiaomiMfaLink").href = xiaomiMfaLink

                document.getElementById("XiaomiPaso1").className = document.getElementById("XiaomiPaso1").className.replaceAll(" hidden", "") + " hidden"                
                document.getElementById("XiaomiPaso2").className = document.getElementById("XiaomiPaso2").className.replaceAll(" hidden", "")
                document.getElementById("fieldsetUsuario").style="display"
                document.getElementById("fieldsetPassword").style="display"                        
                document.getElementById("fieldsetToken").style="display"
                document.getElementById("botonConectarRegistro").style="display"     
                document.getElementById("divMensajeWarning").className = document.getElementById("divMensajeWarning").className.replaceAll(" hidden", "") + " hidden"              

                console.log("Xiaomi - Paso 1 realizado correctamente")
              }
              else{
                //Mensaje rellena form
                document.getElementById("loaderRegistroAplicacion").className="loader hidden"
                initialConfigCommonJS.mostrarMensajeInformativo("No se pudieron validar las credenciales, revísalas e inténtalo de nuevo.","negative")      
              }
              
            } 

            else{ 
              // ERROR  
              document.getElementById("loaderRegistroAplicacion").className="loader hidden"
              initialConfigCommonJS.mostrarMensajeInformativo("No se pudieron validar las credenciales, revísalas e inténtalo de nuevo.","negative")    
            }

            document.getElementById("loaderRegistroAplicacion").className="loader hidden"          

          }
      
          if (this.readyState === 4 && this.status !== 200) { 
            initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)      
          }
        }
        xhttp.send(data);    
    }
    else{
      document.getElementById("loaderRegistroAplicacion").className="loader hidden"
      initialConfigCommonJS.mostrarMensajeInformativo("Introduce tus credenciales.","negative")      
    }

    
  }

  function obtenerLinkAyudaFormulario(){

    var link = ""

    if(params.AppName === "SHELLY"){ link = "https://fevergy.com/pdf/SHELLY.pdf" }
    else if( (params.AppName === "TUYA") || (params.AppName === "SMARTLIFE") ){ link = "https://fevergy.com/pdf/TUYA_SMARTLIFE.pdf" }    
    else if(params.AppName === "EFERGY"){ link = "https://fevergy.com/pdf/EFERGY.pdf" }
    else if(params.AppName === "ECOFORESTCONTROL"){ link = "https://fevergy.com/pdf/ECOFORESTCONTROL.pdf" }
    else if(params.AppName === "TESLA"){ link = "https://fevergy.com/pdf/TESLA.pdf" }
    else if(params.AppName === "HOME_ASSISTANT"){ link = "https://fevergy.com/pdf/HOMEASSISTANT.pdf" }
    else if(params.AppName === "ONECTA_DAIKIN"){ link = "https://fevergy.com/pdf/ONECTA_DAIKIN.pdf" }
    else if(params.AppName === "GOVEE"){ link = "https://fevergy.com/pdf/GOVEE.pdf" }
    else if(params.AppName === "XIAOMI"){ link = "https://fevergy.com/pdf/XIAOMI.pdf" }
    else if(params.AppName === "SMARTTHINGS"){ link = "https://fevergy.com/pdf/SMARTTHINGS.pdf" }
    else { link = "#" }
    
    return link

  }

  function obtenerCodigoOauth(){

    document.getElementById("campoUsuario1").className = ""
    document.getElementById("campoContraseña").className = ""

    if( (document.getElementById("campoUsuario1").value !== "") && (document.getElementById("campoContraseña").value !== "") ){
      document.getElementById("botonConectarRegistro").style="display"      

      var link = document.createElementNS("http://www.w3.org/1999/xhtml", "a");

      if(params.AppName === "ONECTA_DAIKIN"){
        link.href = 'https://idp.onecta.daikineurope.com/v1/oidc/authorize?response_type=code&client_id='+document.getElementById("campoUsuario1").value+'&redirect_uri=https://www.fevergy.com/oauth/Code.html&scope=openid%20onecta:basic.integration'
      }
      else{
        link.href = '#'
      }
      
      link.target = '_blank';   
      var event = new MouseEvent('click', {
          'view': window,
          'bubbles': false,
          'cancelable': true
      });   
      link.dispatchEvent(event);

    }
    else{
      initialConfigCommonJS.mostrarMensajeInformativo("Debes rellenar los campos en rojo para solicitar el código","negative")
      if(document.getElementById("campoUsuario1").value === ""){
        document.getElementById("campoUsuario1").className = "error"
      }
      if(document.getElementById("campoContraseña").value === ""){
        document.getElementById("campoContraseña").className = "error"
      }      
    }

  }

  return (           
    <>
    <header>
      <figure className="avatar size-m orange"><span className="material-icon">cable</span></figure>
      <h1 className="headline-03">Aplicación {initialConfigCommonJS.obtenerLiteralAtributo(params.AppName)}</h1>
    </header>
    <section className="brands">
      <section className="brand-detail">
        <div className="brand-detail-inner">          
          <header>
              <div className="brand-connection">
                  <figure className="avatar size-l"><AppLogoImg aplicacion={params.AppName}/></figure>
                  <figure className="avatar size-l unlinked"><span className="material-icon">electrical_services</span></figure>
                  <figure className="avatar size-l helias"><AppLogoImg aplicacion="HELIAS"/></figure>
              </div>              
          </header>

          <div id="divMensajeError" className="message error left hidden">
            <h1 className="title"><span className="material-icon">error</span>Autenticación incorrecta</h1>
            <p id="mensajeErrorRegistro">Revisa las credenciales e inténtalo de nuevo.</p>
          </div>

          <div id="divMensajeWarningTESLA" className="message warning left hidden">
            <h1 className="title"><span className="material-icon">error</span>Registro sólo disponible en versión web</h1>
            <p>El registro de esta aplicación sólo puede realizarse desde la versión web de Helias. Puedes retomarlo desde la opción <strong>Configuración → Coche</strong>.</p>

            { localStorage.getItem("installationConfigurationMode") === null ?
              <button className="button primary" onClick={() => {initialConfigCommonJS.saltarPaso()}}>Vale, configuraré el coche más tarde.</button>
            :
              <></>
            }            

          </div>
          
          <div id="divMensajeWarning" className="message info left hidden">
            <h1 className="title"><span className="material-icon">info</span>Sigue las instrucciones...</h1>
            <p id="textoMensajeWarning"></p>            
            <a href={obtenerLinkAyudaFormulario()} className="button tertiary size-s" target="_blank" rel="noopener noreferrer">Ver instrucciones</a>
          </div>      

          <div id="divMensajeWarningENERGEEKS_30">
            <div  className="message info left">
              <h1 className="title"><span className="material-icon">info</span>Mejor usa TUYA / SMARTLIFE</h1>
              <p>Energeeks 3.0 es una marca blanca que usa en realidad TUYA / SMARTLIFE, y no integramos aplicaciones de marca blanca, sino que integramos directamente con las principales. Es por eso que para poder usar estos dispositivos en Helias <strong>debes configurar tus actuales dispositivos Energeeks 3.0 en TUYA o SMARTLIFE</strong> y repetir la configuración en Helias seleccionando TUYA o SMARTLIFE.</p>
            </div>
            
            <section className="brands-list" style={{paddingTop: "20px"}}>
              <ul>
                <li id="TUYA" searchvisibility="TUYA">
                  <a href={generalCommonJS.obtenerURLAplicacionDeTerceros("TUYA")} target="_blank" rel="noopener noreferrer">
                    <button className="selector icon-wrapper">
                    <figure className="avatar size-m"><AppLogoImg aplicacion="TUYA"/></figure>
                    <div className="content">
                        <h1 className="brand-name">Descargar TUYA</h1>
                    </div>
                    </button>
                  </a>
                </li>
                
                <li id="SMARTLIFE" searchvisibility="SMARTLIFE">
                  <a href={generalCommonJS.obtenerURLAplicacionDeTerceros("SMARTLIFE")} target="_blank" rel="noopener noreferrer">
                    <button className="selector icon-wrapper" >
                    <figure className="avatar size-m"><AppLogoImg aplicacion="SMARTLIFE"/></figure>
                    <div className="content">
                        <h1 className="brand-name">Descargar SMARTLIFE</h1>
                    </div>
                    </button>
                  </a>
                </li>
              </ul>
            </section>

          </div>

          <div id="divMensajeIberdrolaSmartMonitor" className="message warning left hidden">
            <h1 className="title"><span className="material-icon">error</span>No integramos esta aplicación porque...</h1>
            <p>Esta aplicación es un servicio de Iberdrola con el que instala unos monitores de consumo, que si te cambias de compañía ya no te valen y por los que <strong>cobra 186€ más una cuota mensual de 0.99€ + IVA</strong>.</p>            
            <p>Si tienes una instalación de autoconsumo (Ej: Paneles solares) debes saber que <strong>estás pagando por algo que el fabricante de tu inversor ya te da de forma gratuita y con datos más precisos</strong>. Smart Monitor de Iberdrola funciona como "un medidor de otro medidor principal" (tu inversor). Por eso vemos innecesario integrarnos con esta solución, es mucho mejor <strong>utilizar la aplicación del fabricante de tu inversor</strong>. Por ejemplo, si tienes un inversor HUAWEI utilizarías la aplicación de Fusionsolar. Simplemente <strong>llama al instalador de tu inversor y solicítale las credenciales de acceso. Es tu derecho tenerlas y están obligados a facilitártelas.</strong></p>            
            <p>Y si no tienes una instalación de autoconsumo, <strong>por un 70% menos de ese precio y sin cuotas, tienes medidores de muchísima mejor calidad y que te sirven aunque cambies de comercializadora</strong>. Por ejemplo, <a href="https://shellyspain.com/rele-shelly-em-50a.html" rel="noopener noreferrer" target="_blank" className="link inline-link">este para monofásico</a> y <a href="https://www.shellyespana.com/shelly-3em/" rel="noopener noreferrer" target="_blank" className="link inline-link">este para trifásico</a>.</p>
            <p>Debes saber que puedes abrir una reclamación para que te den de baja el servicio y te reembolsen lo que hayas pagado por el smart monitor.</p>
          </div>

          <div id="divMensajeEDPSolar" className="message warning left hidden">
            <h1 className="title"><span className="material-icon">error</span>No integramos esta aplicación porque...</h1>
            <p>Esta aplicación es un servicio de EDP Solar con el que instala unos monitores de consumo, que si te cambias de compañía ya no te valen y por los que <strong>probablemente te habrán cobrado</strong>.</p>            
            <p>Si tienes una instalación de autoconsumo (Ej: Paneles solares) debes saber que <strong>estás pagando por algo que el fabricante de tu inversor ya te da de forma gratuita y con datos más precisos</strong>. EDP Solar funciona como "un medidor de otro medidor principal" (tu inversor). Por eso vemos innecesario integrarnos con esta solución, es mucho mejor <strong>utilizar la aplicación del fabricante de tu inversor</strong>. Por ejemplo, si tienes un inversor HUAWEI utilizarías la aplicación de Fusionsolar. Simplemente <strong>llama al instalador de tu inversor y solicítale las credenciales de acceso. Es tu derecho tenerlas y están obligados a facilitártelas.</strong></p>            
            <p>Y si no tienes una instalación de autoconsumo, <strong>por un 70% menos de ese precio y sin cuotas, tienes medidores de muchísima mejor calidad y que te sirven aunque cambies de comercializadora</strong>. Por ejemplo, <a href="https://shellyspain.com/rele-shelly-em-50a.html" rel="noopener noreferrer" target="_blank" className="link inline-link">este para monofásico</a> y <a href="https://www.shellyespana.com/shelly-3em/" rel="noopener noreferrer" target="_blank" className="link inline-link">este para trifásico</a>.</p>
            <p>Debes saber que puedes abrir una reclamación para que te den de baja el servicio y te reembolsen lo que hayas pagado.</p>
          </div>

          <fieldset id="formularioCredenciales">

            <form onSubmit={e => { e.preventDefault(); }} autoComplete="off">

            { params.AppName === "ECOFORESTCONTROL" ?
              <>
                <fieldset className="dropdown">
                  <label id="labelmarcaEstufa" htmlFor="labelmarcaEstufa">Marca</label>
                  <div className="icon-wrapper">                    
                    <select id="marcaEstufa">
                      <option value="BIO+">Bio+</option>
                      <option value="ECOFOREST">Ecoforest</option>                    
                    </select>
                  </div>
                </fieldset>           

                <fieldset id="fieldsetPuerto">
                  <label className="has-tooltip">
                    <span id="labelPuerto" htmlFor="labelPuerto">Puerto de conexión</span>                    
                  </label>
                  <input type="number" id="Puerto" onKeyDown={handleKeyDown}/>              
                </fieldset>
              </>
            :
              <></>
            }            

            <fieldset id="divAutenticacionXiaomi" className="actions hidden">
              
              <fieldset>
                
                <div id="XiaomiPaso1">
                  <fieldset>
                    <label className="has-tooltip">
                      <span id="labelUsuarioXiaomi" htmlFor="labelUsuarioXiaomi" className="label tooltip-label">Usuario:</span>                
                    </label>                  
                    <input type="text" id="usuarioXiaomi"/>    
                  </fieldset>

                  <fieldset className="password">
                    <label className="has-tooltip">
                      <span id="labelPasswordXiaomi" htmlFor="labelPasswordXiaomi" className="label tooltip-label">Contraseña:</span>                
                    </label>                  

                    <div className="icon-wrapper">                
                      <input type="password" id="passwordXiaomi" autoComplete="new-password"/>
                    </div>

                  </fieldset>
                  
                  <div className="actions">
                    <button className="button primary" onClick={() => {obtenerLinkXiaomiP1()}}>Continuar</button>          
                  </div>

                </div>

                <div id="XiaomiPaso2">                        
                  <a id="xiaomiMfaLink" className="button tertiary" href="#" target="_blank">Obtener códigos</a>                                  
                </div>
                
              </fieldset>


            </fieldset>

            <fieldset id="fieldsetUsuario">
              <label className="has-tooltip">
                <span id="labelCampoUsuario1" htmlFor="labelCampoUsuario1" className="label tooltip-label"></span>                
              </label>
              <input type="text" id="campoUsuario1" onKeyDown={handleKeyDown}/>    
              
              <div id="divCampoUsuario2" className=" hidden">                
                <input type="text" id="campoUsuario2" onKeyDown={handleKeyDown} />                
              </div>

              <div id="divCampoUsuario3" className=" hidden">
                <input type="text" id="campoUsuario3" onKeyDown={handleKeyDown} />                
              </div>

            </fieldset>

            <fieldset className="password" id="fieldsetPassword">
              <label className="has-tooltip">
                <span id="labelCampoContraseña" htmlFor="labelCampoContraseña" className="label tooltip-label"></span>                
              </label>

              <div className="icon-wrapper">                
                  <input type="password" id="campoContraseña" onKeyDown={handleKeyDown} autoComplete="new-password"/>
              </div>
            </fieldset>

            <div id="divBotonSolicitudCodigoOauth" className="actions hidden">                                                            
              <button className="button tertiary" onClick={() => {obtenerCodigoOauth()}}>Obtener código</button>
            </div>

            <fieldset id="fieldsetToken">
              <label className="has-tooltip">
                <span id="labelCampoToken" htmlFor="labelCampoToken" className="label tooltip-label"></span>                
              </label>

              <input type="text" id="campoToken" onKeyDown={handleKeyDown}/>
              
            </fieldset>
            
            </form>

            <button id="botonConectarRegistro" className="button primary" onClick={() => {registrarNuevaCuenta()}}>Conectar</button>

            <Loader Id="loaderRegistroAplicacion" Mensaje="Registrando aplicacion"/>

          </fieldset>
          
          
          <div id="mensajePrivacidad" className="message privacy hidden">
            <h1 className="title"><span className="material-icon">local_police</span>Privacidad y seguridad garantizadas</h1>
            <p>No nos interesan tus contraseñas y por eso no las guardamos, en su lugar usamos unos tokens criptográficos para que no tengas que estar a diario introduciendo tus credenciales para cada aplicación.</p>
          </div>      
        </div>  
      </section>
    </section>
  </>  
  )
}

export default AppRegistrationForm